export default "__VITE_ASSET__BAp1OKPz__"